import { normalizeSpaces } from './normalizeSpaces'

export const parseSeparatedString = (value: string | null | undefined): string[] =>
  (value ?? '')
    .split(/[,;]/)
    .map((item) => normalizeSpaces(item).trim())
    .filter(Boolean)
